<template>
  <keep-alive>
    <v-container
      fluid
      style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
      class="d-flex flex-column"
    >
      <div
        style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
        class="d-flex flex-row"
      >
        <agency-left-section
          class="hidden-sm-and-down"
          v-if="isAgency"
        />
        <unauth-left-section
          class="hidden-sm-and-down"
          v-else-if="!isAgency && !isVolunteer"
        />
        <volunteer-left-section
          class="hidden-sm-and-down"
          v-else-if="isVolunteer"
        />
        <event-details-section /> 
        <agency-right-section
          class="hidden-md-and-down"
          v-if="isAgency"
        />
        <unauth-right-section
          class="hidden-md-and-down"
          v-else-if="!isAgency && !isVolunteer"
        />
        <volunteer-right-section
          class="hidden-md-and-down"
          v-else-if="isVolunteer"
        />
      </div>
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AgencyLeftSection from "../../agency/AgencyLeftSection.vue";
import AgencyRightSection from "../../agency/AgencyRightSection.vue";
import UnauthLeftSection from '../../agency/UnauthLefSection.vue';
import UnauthRightSection from '../../agency/UnauthRightSection.vue';
import VolunteerLeftSection from "../../volunteer/VolunteerLeftSection.vue";
import VolunteerRightSection from "../../volunteer/VolunteerRightSection.vue";
import EventDetailsSection from "./EventDetailsSection.vue";

export default {
  components: {
    AgencyLeftSection,
    VolunteerLeftSection,
    AgencyRightSection,
    VolunteerRightSection,
    EventDetailsSection,
    UnauthLeftSection,
    UnauthRightSection
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      notifications: [],
      errorCalendars: [],
      token: null,
    };
  },
  methods: {
    ...mapActions("event", {
      fetchAllEvents: "fetchAllEvents"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    },
    fetchToken() {
      this.token = localStorage.getItem("user-token");
      if (this.token) {
        //console.log("Token found:", this.token); 
      } else {
        console.log("Token not found in local storage."); 
      }
    },
  },
  computed: {
    ...mapGetters({
      profileType: "auth/getType"
    }),
    isAgency() {
      return this.profileType === 'Agency' && this.token;
    },
    isVolunteer() {
      return this.profileType === 'Volunteer' && this.token;
    }
  },
  created() {
    this.fetchToken();
  }
};
</script>
<style scoped></style>
